import { createDocumentPDFGenerator } from './documentReportBase';

export const generateDeliveryNotePDF = createDocumentPDFGenerator('ใบส่งงาน', '#7C3AED');
